// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_REGION_DELETE_REQUEST = "NETWORK_REGION_DELETE_REQUEST";
export const NETWORK_REGION_DELETE_REQUEST_SUCCESS =
  "NETWORK_REGION_DELETE_REQUEST_SUCCESS";
export const NETWORK_REGION_DELETE_REQUEST_FAILURE =
  "NETWORK_REGION_DELETE_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_REGION_DELETE_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(res, payload) {
  return {
    type: NETWORK_REGION_DELETE_REQUEST_SUCCESS,
    data: res,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: NETWORK_REGION_DELETE_REQUEST_FAILURE,
    error,
    payload,
  };
}
